import { ChatDealStageRef } from "@mapmycustomers/shared/types/chat/ChatContent";
import Funnel from "@mapmycustomers/shared/types/entity/deals/Funnel";
import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";

// A proposal's own stages belong to its funnel. A conflict's fresh stage may not: BE resolves it
// from the deal's CURRENT funnel, which can differ if the deal moved funnels — so that lookup
// passes no funnelId and searches everything we hold.
export const resolveStage = (
  funnelStages: Record<Funnel["id"], Stage[]>,
  funnelId: Funnel["id"] | undefined,
  ref: ChatDealStageRef
): Stage | undefined => {
  const candidates =
    funnelId === undefined ? Object.values(funnelStages).flat() : (funnelStages[funnelId] ?? []);
  return candidates.find((stage) => stage.id === ref.id);
};

// `freshValues` is Record<string, unknown> — the contract stating there is no contract. Shape-check
// before rendering rather than trusting it.
export const parseFreshStage = (
  freshValues: Record<string, unknown> | undefined
): ChatDealStageRef | undefined => {
  const stage = freshValues?.stage;
  if (typeof stage !== "object" || stage === null) {
    return undefined;
  }
  const { id, name } = stage as Record<string, unknown>;
  return typeof id === "number" && typeof name === "string" ? { id, name } : undefined;
};
